// SPDX-License-Identifier: AGPL-3.0-or-later

import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import KonvoWorkspace, {type TasksChangedEvent} from '@app/features/konvo_tasks/state/KonvoWorkspace';

export function handleKonvoClickUpTasksChanged(data: TasksChangedEvent, _context: GatewayHandlerContext): void {
	if (!data || typeof data !== 'object') return;
	KonvoWorkspace.handleTasksChanged(data);
}
